module.exports = __webpack_public_path__ + "static/media/image3.433ee90c.jpg";